import {
  foreignKey,
  index,
  integer,
  pgEnum,
  pgTable,
  text,
  time,
  uuid,
  varchar,
  boolean,
} from 'drizzle-orm/pg-core';
import { payment_policy } from '@trashlab/api/src/domains/customer/schemas/payment-policy';
import { merchant_account } from '../../billing/schemas/merchant-account';
import {
  defaultFields,
  defaultHistoryFields,
} from '@trashlab/api/drizzle/default';

export const shop_configuration_status = pgEnum('shop_configuration_status', [
  'ACTIVE',
  'INACTIVE',
]);

export const invoicing_strategy = pgEnum('invoicing_strategy', [
  'ON_BOOKING',
  'MANUAL',
]);

export const shop_configuration = pgTable(
  'shop_configuration',
  {
    ...defaultFields.fieldsWithTenantId(),
    lastModifiedBy: uuid('lastModifiedBy'),
    createdBy: uuid('createdBy'),
    legacySystemId: varchar('legacySystemId', { length: 255 }),
    status: shop_configuration_status('status').default('INACTIVE').notNull(),
    shopName: text('shopName').default('').notNull(),
    shopDescription: text('shopDescription').default('').notNull(),
    paymentPolicyId: uuid('paymentPolicyId').notNull(),
    merchantAccountId: uuid('merchantAccountId').references(() => merchant_account.id),
    invoicingStrategy: invoicing_strategy('invoicingStrategy')
      .default('MANUAL')
      .notNull(),
    contractTemplateId: uuid('contractTemplateId'),
    blockDatesWithoutInventory: boolean('blockDatesWithoutInventory')
      .default(false)
      .notNull(),
    blockSameDayOrder: boolean('blockSameDayOrder').default(false).notNull(),
    sameDayOrderCutoffTime: time('sameDayOrderCutoffTime'),
    blockedDaysFromToday: integer('blockedDaysFromToday').default(0).notNull(),
    countInactiveDaysAsRentalDays: boolean('countInactiveDaysAsRentalDays')
      .default(false)
      .notNull(),
    requirePickupDate: boolean('requirePickupDate').default(false).notNull(),
    requirePlacementInstructions: boolean('requirePlacementInstructions')
      .default(false)
      .notNull(),
    showLogoOnShop: boolean('showLogoOnShop').default(true).notNull(),
    shopCustomNotice: text('shopCustomNotice'),
  },
  (table) => {
    return {
      createdAtTs_idx: index('shop_configuration_createdAtTs_idx').on(
        table.createdAtTs,
      ),
      tenantId_idx: index('shop_configuration_tenantId_idx').on(table.tenantId),
      updatedAtTs_idx: index('shop_configuration_updatedAtTs_idx').on(
        table.updatedAtTs,
      ),
      updatedAtTs_idx1: index('shop_configuration_updatedAtTs_idx1').on(
        table.updatedAtTs.desc(),
      ),
      versionNumber_idx: index('shop_configuration_versionNumber_idx').on(
        table.versionNumber,
      ),
      paymentPolicyId_idx: index('shop_configuration_paymentPolicyId_idx').on(
        table.paymentPolicyId,
      ),

      //foreign keys
      shop_configuration_paymentPolicyId_fkey: foreignKey({
        columns: [table.paymentPolicyId],
        foreignColumns: [payment_policy.id],
        name: 'shop_configuration_paymentPolicyId_fkey',
      }),
    };
  },
);

export const shop_configuration_history = pgTable(
  'shop_configuration_history',
  {
    ...defaultHistoryFields.historyFieldsWithTenantId(),
    lastModifiedBy: uuid('lastModifiedBy'),
    createdBy: uuid('createdBy'),
    legacySystemId: varchar('legacySystemId', { length: 255 }),
    status: shop_configuration_status('status'),
    shopName: text('shopName'),
    shopDescription: text('shopDescription'),
    paymentPolicyId: uuid('paymentPolicyId'),
    merchantAccountId: uuid('merchantAccountId'),
    invoicingStrategy: invoicing_strategy('invoicingStrategy'),
    contractTemplateId: uuid('contractTemplateId'),
    blockDatesWithoutInventory: boolean('blockDatesWithoutInventory'),
    blockSameDayOrder: boolean('blockSameDayOrder'),
    sameDayOrderCutoffTime: time('sameDayOrderCutoffTime'),
    blockedDaysFromToday: integer('blockedDaysFromToday'),
    countInactiveDaysAsRentalDays: boolean('countInactiveDaysAsRentalDays'),
    requirePickupDate: boolean('requirePickupDate'),
    requirePlacementInstructions: boolean('requirePlacementInstructions'),
    showLogoOnShop: boolean('showLogoOnShop'),
    shopCustomNotice: text('shopCustomNotice'),
  },
);
